import { defineComponent as H, useSlots as D, ref as f, openBlock as r, createBlock as m, unref as l, withCtx as d, createElementBlock as s, renderSlot as v, createElementVNode as i, normalizeStyle as k, createCommentVNode as A, normalizeClass as C, createVNode as y, createTextVNode as p, toDisplayString as w, Fragment as F, renderList as P, h as R, nextTick as M } from "vue";
import O from "./ghl-ui.es414.js";
import j from "./ghl-ui.es189.js";
import T from "./ghl-ui.es447.js";
import G from "./ghl-ui.es207.js";
import J from "./ghl-ui.es235.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es50.js";
import "./ghl-ui.es13.js";
import K from "./ghl-ui.es448.js";
import "./ghl-ui.es449.js";
import S from "./ghl-ui.es132.js";
import V from "./ghl-ui.es72.js";
import Q from "./ghl-ui.es126.js";
import W from "./ghl-ui.es281.js";
const X = {
  key: 0,
  class: "brand-color-icon"
}, Y = { class: "brand-color-container" }, Z = { class: "brand-color-popover-content" }, _ = {
  key: 0,
  class: "brand-color-container"
}, ee = /* @__PURE__ */ i("div", { class: "brand-default-container-divider" }, null, -1), te = { class: "default-color-text" }, oe = {
  key: 1,
  ref: "pickerContainer",
  class: "brand-color-picker-container"
}, le = ["onClick"], ae = ["onClick"], re = {
  key: 0,
  class: "default-color-swatches"
}, ne = H({
  __name: "BrandColorPicker",
  props: {
    showArrow: {
      type: Boolean,
      default: !1
    },
    placement: {
      type: String,
      default: "bottom"
    },
    defaultValue: {
      type: String,
      default: "#ffffff"
    },
    value: {
      type: String
    },
    swatches: {
      type: Array,
      default: () => []
    },
    defaultLabel: {
      type: String
    },
    paletteTrigger: {
      type: Function,
      default: void 0
    },
    brandColors: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: void 0
    },
    to: {
      type: [String, HTMLElement, Boolean],
      default: void 0
    },
    showAlpha: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    trigger: {
      type: String,
      default: "click",
      description: "trigger for swatches type"
    },
    baseColors: {
      type: Array,
      default: () => ["#FFFFFFFF", "#000000FF"]
    },
    brandColorPlacement: {
      type: String,
      default: "bottom-end"
    },
    disableBrandSection: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:value",
    "route:brand-boards",
    "update:show",
    "onRemoveColor",
    "onAddColor",
    "onChangeColor"
  ],
  setup(e, { emit: $ }) {
    const x = J("BrandColorPicker"), u = e, g = D(), U = f(!1), N = f(!1), B = f(!1), b = f(null), c = f(""), n = $, E = () => R(
      V,
      {
        id: "brand-picker-trigger",
        class: "brand-picker-trigger-btn",
        onClick: () => U.value = !0,
        text: !0
      },
      () => [
        R(O, {
          class: "brand-color-trigger-icon"
        }),
        "Add"
      ]
    ), I = (o) => {
      if (!(u.baseColors.includes(o) || u.swatches.includes(o))) {
        if (B.value && c.value !== "") {
          const a = u.swatches.slice(0, -1);
          n("onChangeColor", {
            oldColor: c.value,
            newColor: o,
            swatches: [...a, o]
          }), c.value = o;
        } else
          c.value = o, n("onAddColor", {
            added: o,
            swatches: [...u.swatches, o]
          });
        M(() => {
          b.value.scrollTop = b.value.scrollHeight;
        });
      }
    }, L = (o, a) => {
      a.stopImmediatePropagation(), n("onRemoveColor", {
        removed: o,
        swatches: u.swatches.filter((t) => t !== o)
      });
    }, q = (o) => {
      o || (c.value = ""), B.value = o, n("update:show", o);
    };
    return (o, a) => (r(), m(l(S), {
      class: "brand-color-popover",
      trigger: e.trigger,
      placement: e.brandColorPlacement,
      show: e.show,
      showArrow: e.showArrow,
      to: e.to,
      disabled: e.disabled
    }, {
      trigger: d(() => [
        l(g).trigger ? (r(), s("div", X, [
          v(o.$slots, "trigger")
        ])) : (r(), m(l(V), {
          key: 1,
          id: "brand-color-trigger-btn",
          class: "brand-color-button",
          disabled: e.disabled,
          text: "",
          onClick: a[0] || (a[0] = (t) => N.value = !0)
        }, {
          default: d(() => [
            i("div", Y, [
              i("div", {
                class: "brand-color-value",
                style: k({ backgroundColor: e.value || e.defaultValue })
              }, null, 4)
            ])
          ]),
          _: 1
        }, 8, ["disabled"]))
      ]),
      default: d(() => [
        i("div", Z, [
          e.disableBrandSection ? A("", !0) : (r(), s("div", _, [
            l(g).header ? v(o.$slots, "header", { key: 0 }) : (r(), m(K, {
              key: 1,
              "brand-colors": l(G)(u.brandColors, "hexa"),
              "onUpdate:value": a[1] || (a[1] = (t) => n("update:value", t)),
              "onRoute:brandBoards": a[2] || (a[2] = (t) => n("route:brand-boards")),
              value: e.value
            }, null, 8, ["brand-colors", "value"])),
            ee
          ])),
          i("div", {
            class: C([
              "default-color-container",
              e.disableBrandSection ? "pt-4" : ""
            ])
          }, [
            i("div", te, [
              y(l(Q), null, {
                default: d(() => [
                  p(w(`${e.defaultLabel || l(x).default}`), 1)
                ]),
                _: 1
              }),
              l(g).headerRight ? v(o.$slots, "headerRight", { key: 0 }) : (r(), s("div", oe, [
                y(l(W), {
                  class: "brand-default-picker",
                  "render-label": e.paletteTrigger || E,
                  value: e.value || e.defaultValue,
                  "default-value": e.defaultValue,
                  placement: e.placement,
                  "default-show": !1,
                  "show-alpha": e.showAlpha,
                  modes: ["hex"],
                  onComplete: I,
                  "onUpdate:value": a[3] || (a[3] = (t) => n("update:value", t)),
                  "onUpdate:show": a[4] || (a[4] = (t) => q(t))
                }, null, 8, ["render-label", "value", "default-value", "placement", "show-alpha"])
              ], 512))
            ]),
            i("div", {
              ref_key: "defaultColorsRef",
              ref: b,
              class: "default-color-swatches"
            }, [
              (r(!0), s(F, null, P(l(T)(e.baseColors), (t, h) => (r(), m(l(S), {
                key: h,
                class: "default-color-swatch"
              }, {
                trigger: d(() => [
                  (r(), s("div", {
                    key: t.toString(),
                    class: C(["default-color-swatch-item", { active: t === e.value }]),
                    style: k({ backgroundColor: t.toString() }),
                    onClick: () => n("update:value", t)
                  }, null, 14, le))
                ]),
                default: d(() => [
                  p(" " + w(t.toString()), 1)
                ]),
                _: 2
              }, 1024))), 128)),
              (r(!0), s(F, null, P(l(T)(e.swatches), (t, h) => (r(), m(l(S), {
                key: h,
                class: "default-color-swatch"
              }, {
                trigger: d(() => [
                  (r(), s("div", {
                    key: t.toString(),
                    class: C(["default-color-swatch-item", { active: t === e.value }]),
                    style: k({ backgroundColor: t.toString() }),
                    onClick: () => n("update:value", t)
                  }, [
                    y(l(j), {
                      onClick: (z) => L(t, z),
                      class: "default-color-swatch-item-close"
                    }, null, 8, ["onClick"])
                  ], 14, ae))
                ]),
                default: d(() => [
                  p(" " + w(t.toString()), 1)
                ]),
                _: 2
              }, 1024))), 128))
            ], 512),
            l(g).action ? (r(), s("div", re, [
              v(o.$slots, "action")
            ])) : A("", !0)
          ], 2)
        ])
      ]),
      _: 3
    }, 8, ["trigger", "placement", "show", "showArrow", "to", "disabled"]));
  }
}), we = ne;
export {
  we as default
};
